var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      class: _vm.classes,
      attrs: { href: "#" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.organisationInformation($event)
        }
      }
    },
    [
      _vm.hideChevron
        ? _c("span", [
            _vm._v("\n    " + _vm._s(_vm.$t("Organisation.Title")) + "\n  ")
          ])
        : _c("span", [
            _c("i", { staticClass: "fas fa-chevron-right" }),
            _vm._v(" " + _vm._s(_vm.$t("Organisation.Title")) + "\n  ")
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }